const BUS_UPDATED = (state, Bus) => {
  state.Bus = Bus
}

export default {
  BUS_UPDATED
}
